var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#52009a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON",
    transform: "translate(-0.271 -0.346)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    width: 76,
    height: 76,
    rx: 20,
    transform: "translate(0.271 0.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "microphone",
    transform: "translate(-53.065 17.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(78.336 19.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M104.687,210.861a1.453,1.453,0,0,0-2.906,0,10.269,10.269,0,1,1-20.538,0,1.453,1.453,0,0,0-2.906,0,13.173,13.173,0,0,0,11.722,13.127v3.875h-5.28a1.453,1.453,0,0,0,0,2.906H98.244a1.453,1.453,0,0,0,0-2.906h-5.28v-3.875A13.173,13.173,0,0,0,104.687,210.861Z",
    transform: "translate(-78.336 -209.408)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(83.422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M140.185,0A8.1,8.1,0,0,0,132.1,8.089V21.216a8.089,8.089,0,1,0,16.178.048V8.089A8.1,8.1,0,0,0,140.185,0Z",
    transform: "translate(-132.096)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMic);
export default __webpack_public_path__ + "static/media/icon-mic.fea2d2815fc7f54731f3b333e635b223.svg";
export { ForwardRef as ReactComponent };